import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm-amano-one-sync',
  standalone: true,
  imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './dialog-confirm-amano-one-sync.component.html',
  styleUrl: './dialog-confirm-amano-one-sync.component.scss',
})
export class DialogConfirmAmanoOneSyncComponent {
  numberOfParkersToSync: number = 0;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmAmanoOneSyncComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { syncData: number },
  ) {
    this.numberOfParkersToSync = data.syncData;
  }
}
